import UploadFileOutlined from "@mui/icons-material/UploadFileOutlined";
import { Tooltip } from "@mui/material";

import { CoAppActionButton } from "@/components/global/styled/global.styled";

interface CollectionImportCsvButtonProps {
	onClick: () => void;
}

export default function CollectionImportCsvButton({ onClick }: CollectionImportCsvButtonProps) {
	return (
		<Tooltip title="First column only; no header — row 1 is a value" arrow>
			<CoAppActionButton onClick={onClick} startIcon={<UploadFileOutlined />}>
				Import CSV
			</CoAppActionButton>
		</Tooltip>
	);
}
